import React from "react";
import PropTypes from 'prop-types';

import style from "./LinkBar.css";

const LinkBar = ({ links, selected, onClick, activeStyle = {} }) => {
  return (
    <div className={style.links}>
      {links.map((link, idx) => {
        const overrides = idx === selected ? activeStyle : {};

        return (
          <span
            key={idx}
            className={idx === selected ? style.active : style.link}
            style={overrides}
            onClick={() => onClick(idx)}>
            {link}
          </span>
        );
      })}
    </div>
  );
};

LinkBar.propTypes = {
  links: PropTypes.array.isRequired,
  selected: PropTypes.number.isRequired,
  onClick: PropTypes.func.isRequired,
  activeStyle: PropTypes.object
};

export default LinkBar;



// WEBPACK FOOTER //
// ./component/LinkBar/index.js